import { isEmpty, omit } from "lodash";

export const promoGoodsAdapter = (goods, goodsList) => Object.keys(goods).reduce((acc, key) => {
    const item = goods[key];
    const good = goodsList.find((el) => el.id === item.value);
    return [
        ...acc,
        {
            id: item.value,
            price: item.sale,
            name: item.label,
            article: item.article,
            count: item.count || 1,
            isPromo: true,
            description: (good && good.description) ? good.description : null,
            category: (good && good.category && good.category.id) ? good.category.id : null,
        },
    ];
  }, []);

export const promocodeAdapter = (promocode) => {
    const data = omit(promocode, ['city', 'updated_at', 'created_at']);
    data.goods = isEmpty(data.goods)
        ? {}
        : data.goods.reduce((acc, item) => ({ ...acc, [item.value]: item }), {});
    return data;
};